module.exports = __webpack_public_path__ + "img/box_opened_vector_.bd4d31a2.png";